import ConversionResultFormatter from './conversionResultFormatter.js';

class FeetInchFormatter extends ConversionResultFormatter{
    constructor(lengthQuantity, feetSymbolIndex, inchSymbolIndex) {
        super();

        this.inchesSymbol = lengthQuantity.getUnit('in').getSymbol(inchSymbolIndex) || "″";
        this.feetSymbol = lengthQuantity.getUnit('ft').getSymbol(feetSymbolIndex) || "′";
        this.lengthQuantity = lengthQuantity;
    }

    stringify (value, thousandSeparator, decimalSeparator){
        const isValueNegative = value < 0;
        let feet = isValueNegative ? Math.ceil(value) : Math.floor(value);
        let decimalPart = Math.abs(value - feet);
        let stringified = '';

        if (feet) {
            stringified = feet + this.feetSymbol;
        }
        else if(isValueNegative){
            stringified = '-';
        }

        if(decimalPart) {
            let inches = decimalPart * 12;
            if( inches < 1 ){
                if (feet){
                    stringified += ' ';
                }
                if( inches > 0.875 ){
                    stringified += '1' + this.inchesSymbol;
                }
                else if( inches > 0.625 ){
                    stringified +=	'¾' + this.inchesSymbol;
                }
                else if( inches > 0.375 ){
                    stringified +=	'½' + this.inchesSymbol;
                }
                else if( inches > 0.125 ){
                    stringified +=	'¼' + this.inchesSymbol;
                }
                else if( inches > 0.1 ){
                    stringified +=	'⅛' + this.inchesSymbol;
                }
                else if( inches >= 0.05){
                    stringified += '⅒' + this.inchesSymbol;
                }
            }
            else {
                if (feet) {
                    stringified += ' ' + Math.round(inches) + this.inchesSymbol;
                }
                else if(isValueNegative){
                    stringified = Math.round(inches * -1) + this.inchesSymbol;
                }
                else{
                    stringified = Math.round(inches) + this.inchesSymbol;
                }
            }
        }
        else if (!feet) {
            stringified += '0' + this.inchesSymbol;
        }

        return stringified;
    }

    stringifyUnitSymbol (stringified, symbolPrefix, symbolSuffix, unit, unitSymbolIndex) {
        let newFootSymbol = this.lengthQuantity.getUnit('ft').getSymbol(unitSymbolIndex) || "′";
        let newInchSymbol = this.lengthQuantity.getUnit('in').getSymbol(unitSymbolIndex) || "″";
        return stringified
            .replace(this.feetSymbol, `${symbolPrefix || ''}${newFootSymbol}${symbolSuffix || ''}`)
            .replace(this.inchesSymbol, `${symbolPrefix || ''}${newInchSymbol}${symbolSuffix || ''}`);
    }
}

export default FeetInchFormatter;